export default "__VITE_ASSET__BXca4GbQ__"